<template>
  <div class="page">
    <div class="card_wrapper">
      <div v-if="allData && !impersonation" class="welcome">
        <h1 class="welcome__title">{{allData.patient.firstName + ' ' + allData.patient.lastName}}</h1>     
        <h2 class="welcome__subtitle" v-if="triedToResetPassword">Please log out before attempting to reset a password</h2>
        <h2 class="welcome__subtitle" v-if="cdaList.length === 0">Upload a <router-link to="/cdas">document</router-link> to get started</h2>
        <h2 class="welcome__subtitle" v-if="impersonation && !invited"><a href='#' @click.prevent=invite>(Invite)</a></h2>
        <h2 class="welcome__subtitle" v-if="impersonation && invited"><a href='#' @click.prevent=uninvite>(Revoke Invitation)</a></h2>
      </div>
      <div v-else class="welcome__card">
        <h2 class="header capitalize homecard">
          <span v-if="allData.patient.firstName">{{ allData.patient.firstName.toLowerCase()+" " }}</span>
          <span v-if="allData.patient.middleName">{{ allData.patient.middleName.toLowerCase()+" " }}</span>
          <span v-if="allData.patient.lastName">{{ allData.patient.lastName.toLowerCase() }}</span>
        </h2>
        <welcome-bio :patient="allData.patient" />
      </div>
      <div v-if="impersonation && favorite" class="welcome__card">
        <h2 class="header capitalize homecard">
          <span> {{ favorite.id.length > 20 ? allData.relationDescriptions.find(rel => rel.id == favorite.relationType).value : favorite.id }} </span>
        </h2>
        <div class="table-container">
          <table class="emergency_table" aria-label="welcome biography">
            <tr v-if="favorite.firstName || favorite.lastName">
              <td class="welcome__info">
              <font-awesome-icon icon="pencil-alt" class="icon"/><b> Name: </b> {{ favorite.firstName ? favorite.firstName+" " : "" }}{{ favorite.lastName ? favorite.lastName : ""}}
              </td>
            </tr>
            <tr v-if="favorite.primaryPhone">
              <td class="welcome__info">
                <font-awesome-icon icon="phone" class="icon"/><b>{{favorite.primaryPhoneType ? allData.phoneTypes.find(type => type.id == favorite.primaryPhoneType).type + ': ' : 'Primary: '}}</b><a class="phone1" :href="'tel:'+favorite.primaryPhone">{{favorite.primaryPhone}}</a>
              </td>
            </tr>
            <tr v-if="favorite.secondaryPhone">
              <td class="welcome__info">
                <font-awesome-icon icon="phone" class="icon"/><b>{{favorite.secondaryPhoneType ? allData.phoneTypes.find(type => type.id == favorite.secondaryPhoneType).type + ': ' : 'Secondary: '}}</b><a class="phone1" :href="'tel:'+favorite.secondaryPhone">{{favorite.secondaryPhone}}</a>
              </td>
            </tr>
            <tr v-if="favorite.email">
              <td class="welcome__info">
                <font-awesome-icon icon="inbox" class="icon"/><b> E-mail: </b><a class="email" :href="'mailto:'+favorite.email">{{favorite.email}}</a>
              </td>
            </tr>
            <tr v-if="getFullAddress() != ''">
              <td class="welcome__info">
                <font-awesome-icon icon="map-marker-alt" class="icon"/><b> Address: </b>{{getFullAddress()}}
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <welcome-quick-nav :key='allData.patient.externId'></welcome-quick-nav>
  </div>

</template>

<script>
import { mapGetters } from 'vuex';
import WelcomeQuickNav from './WelcomeQuickNav';
import WelcomeBio from './WelcomeBio'
import {getImpersonation,getInvited} from "@/data/getters";
import { revertToSelf,invitePatient,uninvitePatient } from '@/api/sessionApi';
import { getPrimaryContact } from "@/data/getters";
import { getContacts } from "@/api/userApi";

  
export default {
  name: "welcome-page",
  data() {
    return {
      favorite: null,
    }
  },
  components: {
    'welcome-quick-nav': WelcomeQuickNav,
    'welcome-bio': WelcomeBio
  },
  created() {
    let loader = this.$loading.show({},{
      after: this.$createElement('div',{},['Loading account data...'])
    });
    getContacts().then((a) => {
      this.favorite = getPrimaryContact(a)
      loader.hide()
      loader = null
    })
    .catch((err) => {
      console.log(err)
      alert(err)
      loader.hide()
      loader = null
    })
  },
    // setTimeout(() => {
    //   loader.hide()
    //   loader = null
    // }, 3500)
  computed: {
    triedToResetPassword() {
      return 'triedToResetPassword' in window.sessionStorage && 
        (window.sessionStorage.triedToResetPassword - Date.now() < (40 * 1000))
    },
    ...mapGetters('login',{
      allData: 'getAllData',
      // user: 'getUser',
      isLoggedIn: 'isLoggedIn'
    }),
    ...mapGetters('login/cda', {
      cdaList: 'getCdaList',
    }),
    impersonation: function() {
      return getImpersonation(this.allData);
    },
    invited: function() {
      return getInvited(this.allData);
    }
  },
  methods: {
    revert: function() {
      revertToSelf()
        .then(()=>setTimeout(()=>{ window.location.reload(); },6800));
    },
    invite: function() {
      invitePatient()
        .then(()=>setTimeout(()=>{ window.location.reload(); },800));
    },
    uninvite: function() {
      uninvitePatient()
        .then(()=>setTimeout(()=>{ window.location.reload(); },800));
    },
    getFullAddress(){ 
      let answer = ''
      let values = [this.favorite.address1, this.favorite.address2, this.favorite.city]
      values.forEach(function (item){
        if (item){
          if (answer==='')
            answer+=item
          else
            answer= answer + ', ' + item
        }
      })
      if (this.favorite.state) {
        let stateName = this.allData.states.find(state => state.id == this.favorite.state).name
        if (answer == '')
          answer += stateName
        else
          answer = answer + ', ' + stateName
      }
      if (this.favorite.zip) {
        if (answer == '')
          answer += this.favorite.zip
        else
          answer = answer + ', ' + this.favorite.zip
      }
      return answer
    }
  }
}
</script>

<style scoped lang="scss">
  $color-font: #58595b;

  .page {
    margin: 0 auto;
    width: 100%;
  }
  .welcome {
    text-align: center;
    flex: 1;
  }
  .welcome__title {
    font-size: 1.8em;
    color: $color-font;
  }
  .welcome__subtitle {
    font-size: 1.3em;
    color: $color-font;
  }

  .card_wrapper {
    text-align: center;
    // width: 700px;
    margin: auto;
    display: flex;
  }

  .welcome__info {
    color: $color-font;
    line-height: 1.8em;
  }

  .icon {
    margin-right: 0.5em;
  }
  .welcome__card {
    border: 1px solid lightgray;
    border-radius: 5px;
    margin: 0 auto;
    width: 700px;
    text-align: left;
    display: inline-block;
    flex: 1;
  }

  .header {
    text-align: center;
    color: #fff;
    font-size: 1.2em;
    padding: 5px 0;
    background-color: #007bff;
  }

  .homecard {
    margin-top: unset;
  }

  .capitalize {
    text-transform: capitalize;
  }

  .table-container {
    padding: 1em 2em 1.5em;
  }

  @media only screen and (max-width: 768px) {
    .page {
      padding-bottom: 0;
    }
    .welcome__title {
      font-size: 1.5em;
    }
  }
</style>
